import BackIcon from "../../../assets/communication/Back.svg";

export const RewardInventoryDefinitionHeader = (props) => {
  return (
    <div className="inventory_body">
        <div className="inventory_addheader" >
          <div className="back-title-group" onClick={(e)=> props.backBtncallback(e)}>
            <img src={BackIcon} className="back-icon" />
            <span className="back-text">Back</span>
          </div>
        </div>
    </div>
  );
};